export default __webpack_public_path__ + "static/media/beeBack.73739f73.jpg";